export function industrySnapshotTab(config, Alpine) {
  return {
    activeSVGTab: config.activeState || "QLD",
    changeState($event) {
      this.activeSVGTab = $event.target.closest(".js-state").dataset.id ? $event.target.closest(".js-state").dataset.id : this.activeSVGTab;
    }
  };
}
